const all = ['assigningAuthorities']
const list = [...all, 'list']

export const assigningAuthoritiesKeys = {
  all,
  list,
}
